import { render, staticRenderFns } from "./EscolhaContatoBeneficiario.vue?vue&type=template&id=ec9fc9d6"
import script from "./EscolhaContatoBeneficiario.vue?vue&type=script&lang=js"
export * from "./EscolhaContatoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./EscolhaContatoBeneficiario.vue?vue&type=style&index=0&id=ec9fc9d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports